<template>
    <UModal
        prevent-close
        :overlay="true"
        fullscreen
        :ui="{ background: 'bg-transparent', fullscreen: 'w-screen h-screen md:my-5 md:w-[80%] md:h-auto lg:h-auto lg:w-[60%]' }">
        <UCard
            :ui="{
                ring: '',
                divide: 'divide-y divide-gray-100 dark:divide-gray-800'
            }">
            <template #header>
                <div class="relative flex items-center justify-center">
                    <h3 class="text-center text-xl font-semibold leading-6 text-dark-950">ROI CALCULATOR</h3>

                    <UButton
                        type="button"
                        class="absolute -right-2 top-1 -my-2"
                        color="white"
                        variant="outline"
                        icon="i-bi-x"
                        size="xs"
                        square
                        @click="isModalCloseInvestorCalculator" />
                </div>
            </template>

            <UTabs
                :items="items"
                :ui="{
                    list: {
                        background: 'bg-green-500',
                        height: 'h-14',
                        marker: {
                            wrapper: 'absolute top-[4px] left-[4px] duration-200 ease-out focus:outline-none',
                            base: 'w-full h-full',
                            background: 'bg-green-950',
                            rounded: 'rounded-md',
                            shadow: 'shadow-sm'
                        },
                        tab: {
                            background: 'tracking-tighter',
                            active: 'text-white',
                            inactive: 'text-green-950',
                            height: 'h-12',
                            padding: 'px-3',
                            size: 'text-[10px] md:text-xl lg:text-xl',
                            font: 'font-bold',
                            rounded: 'rounded-md',
                            shadow: '',
                            icon: 'w-6 h-6 flex-shrink-0 me-2'
                        }
                    }
                }">
                <template #item="{ item }">
                    <ULandingCTA
                        :title="`${item.content.text}`"
                        :description="`${item.content.span}`"
                        card
                        :links="[
                            {
                                to: '/agarwood-plantation-ownership',
                                label: 'Download Your FREE Guide',
                                color: 'landing',
                                size: 'xl',
                                click: () => isModalCloseInvestorCalculator()
                            }
                        ]"
                        :ui="{
                            wrapper: 'relative mt-4 bg-green-500 ring-green-500 rounded-md',
                            body: {
                                base: 'flex flex-col gap-16 sm:gap-y-10',
                                padding: 'py-4 sm:py-6 sm:px-6'
                            },
                            title: 'mt-20 px-2 items-center text-2xl font-semibold tracking-tight text-green-950',
                            description: 'mt-2 px-2 text-6xl font-extrabold text-green-950',
                            links: 'mt-6 mx-4 flex items-center justify-center gap-x-6'
                        }">
                        <UIcon :name="item.content.icon" class="absolute left-0 right-0 top-1 mx-auto h-24 w-24 text-green-950" />
                    </ULandingCTA>
                </template>
            </UTabs>
        </UCard>
    </UModal>
</template>

<script setup>
    const { modalOpenInvestorCalculator } = inject('investor-calculator-modal')

    const isModalCloseInvestorCalculator = () => {
        modalOpenInvestorCalculator.value = false
    }

    const items = [
        {
            label: '$6,250',
            content: {
                text: 'YOUR PLANTATION WILL RETURN A PROFIT OF',
                icon: 'i-ph-plant',
                span: '$14,700*'
            }
        },
        {
            label: '$12,500',
            content: {
                text: 'YOUR PLANTATION WILL RETURN A PROFIT OF',
                icon: 'i-ph-plant',
                span: '$29,400*'
            }
        },
        {
            label: '$25,000',
            content: {
                text: 'YOUR PLANTATION WILL RETURN A PROFIT OF',
                icon: 'i-ph-plant',
                span: '$58,800*'
            }
        },
        {
            label: '$50,000',
            content: {
                text: 'YOUR PLANTATION WILL RETURN A PROFIT OF',
                icon: 'i-ph-plant',
                span: '$117,600*'
            }
        },
        {
            label: '$125,000',
            content: {
                text: 'YOUR PLANTATION WILL RETURN A PROFIT OF',
                icon: 'i-ph-plant',
                span: '$294,000*'
            }
        }
    ]
</script>
